/**
 * Field contract for FMB receipt list filters (sources + labels).
 */
export const FMB_RECEIPT_FILTER_FIELDS = [
  { source: "q", label: "Search", kind: "text" as const },
  { source: "paymentMode", label: "Payment Mode", kind: "select" as const },
  { source: "startDate", label: "Start Date", kind: "date" as const },
  { source: "endDate", label: "End Date", kind: "date" as const },
] as const;

export const FMB_RECEIPT_FILTER_SOURCES = FMB_RECEIPT_FILTER_FIELDS.map((f) => f.source);
